// @flow
import React, { useState } from 'react';
import { DefaultForm, DefaultFormGlobalValidation, DefaultFormSubmit, DefaultFormDropDown } from '../../elements/DefaultForm';
import { offlineTokenMetaModel } from '../model/OfflineToken.model';
import Loader from '../../elements/Loader';
import LoadFailed from '../../elements/LoadFailed';
import ErrorCapsule from '../../core/exceptions/ErrorCapsule';
import type { Office } from '../../org/model/Office.model';

export type OfflineTokenCreatePageViewProps = {
  offices: null | Array<Office> | ErrorCapsule,
  createdToken: ?string,
  onSubmit: (values: Object) => void,
}

export default function OfflineTokenCreatePageView({
  offices, createdToken, onSubmit,
}: OfflineTokenCreatePageViewProps) {
  if (!offices) return <Loader />;
  if (offices instanceof ErrorCapsule) return <LoadFailed error={offices} />;

  const officeOptions = offices.map(o => [o.id, o.title]);

  if (createdToken) {
    return (
      <div className="offline-token-create">
        <h1>Токен создан</h1>
        <div className="card bg-light p-3 mb-3">
          <p className="mb-2">Скопируйте токен и передайте оператору:</p>
          <div className="input-group">
            <input
              type="text"
              className="form-control font-monospace"
              value={createdToken}
              readOnly
              id="created-token-input"
              style={{ fontFamily: 'monospace' }}
            />
            <div className="input-group-append">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => {
                  const input = document.getElementById('created-token-input');
                  if (input instanceof HTMLInputElement) {
                    input.select();
                    document.execCommand('copy');
                  }
                }}
              >
                Копировать
              </button>
            </div>
          </div>
          <p className="text-muted mt-2 mb-0 small">
            Токен показывается только один раз. Скопируйте его сейчас.
          </p>
        </div>
        <a href="/offline/tokens/" className="btn btn-primary">К списку токенов</a>
      </div>
    );
  }

  return (
    <div className="offline-token-create">
      <h1>Создание офлайн токена</h1>
      <DefaultForm
        form="offlineTokenCreate"
        metaModel={offlineTokenMetaModel}
        initialValues={{}}
        onSubmit={onSubmit}
      >
        <DefaultFormGlobalValidation />
        <DefaultFormDropDown
          attribute="officeId"
          options={officeOptions}
          autoFocus
        />
        <p className="text-muted small">
          Токен будет привязан к первому устройству, с которого войдут. Повторное использование с другого ПК невозможно.
        </p>
        <DefaultFormSubmit label="Создать токен" />
      </DefaultForm>
    </div>
  );
}
